import { SET_USERS, SET_CURRENT_USER, SET_GROUPS } from '../../constants';

const initialState = {
  usersList: [],
  currentUserInfo: [],
  groupsList: [],
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return { ...state, usersList: action.users };
    case SET_CURRENT_USER:
      return { ...state, currentUserInfo: action.user };
    case SET_GROUPS:
      return { ...state, groupsList: action.groups };
    default:
      return state;
  }
};

export default adminReducer;
